export default __webpack_public_path__ + "static/media/franchise-logo-default.a1da391f.png";